import React from "react";
import Theme from "@/components/Theme";
import { IS_LIVE } from "@/utils/constants";
import Hero from "@/organisms/Hero";
import BlogArticles from "@/organisms/BlogArticles";
import Discover from "@/organisms/Discover";
import PromoSection from "@/organisms/PromoSection";
import CommunitySupportSection from "@/components/organisms/CommunitySupportSection";

export default function GivingBack() {
  const seoData = {
    indexing: true,
    title: "AnswerForce Giving Back Program, made possible by customers",
    description:
      "Thanks to the support of AnswerForce customers, the Giving Back program helps families across the United States and beyond. Learn more.",
    og: {
      title: "AnswerForce Giving Back Program, made possible by customers",
      description:
        "Thanks to the support of AnswerForce customers, the Giving Back program helps families across the United States and beyond. Learn more.",
      url: "https://www.answerforce.com/giving-back",
      image:
        "https://assets.answerforce.com/answerforce/us/website/images/og/giving-back-og.jpg",
    },
    twitter: {
      title: "AnswerForce Giving Back Program, made possible by customers",
      description:
        "Thanks to the support of AnswerForce customers, the Giving Back program helps families across the United States and beyond. Learn more.",
      url: "https://www.answerforce.com/giving-back",
      image:
        "https://assets.answerforce.com/answerforce/us/website/images/og/giving-back-og.jpg",
      image_alt: "AnswerForce Giving Back Program, made possible by customers",
    },
  };

  const heroImgData = {
    fileName: "giving-back-hero",
    alt: "Giving back",
  };

  const blogCardData = [
    {
      label: "Giving back",
      readTime: "5 mins read",
      href: "https://www.answerforce.com/blog/archangel-ancient-tree-archive/",
      description:
        "You Grow, We Plant - Partnering with Archangel<span class='dot'>.</span>",
      image: {
        fileName: "blog-giving-back-04-2x",
        alt: "You Grow, We Plant",
        desktopWidth: "360",
        mobileWidth: "280",
        has2XWebp: "true",
      },
    },
    {
      label: "Giving back",
      readTime: "4 mins read",
      href: "https://www.answerforce.com/blog/giving-back-to-united-food-bank/",
      description: "Giving Back to United Food Bank<span class='dot'>.</span>",
      image: {
        fileName: "blog-giving-back-05-2x",
        alt: "Giving Back to United Food Bank",
        desktopWidth: "360",
        mobileWidth: "280",
        has2XWebp: "true",
      },
    },
    {
      label: "Giving back",
      readTime: "4 mins read",
      href: "https://www.answerforce.com/blog/2-million-meals/",
      description: "2 million meals donated<span class='dot'>.</span>",
      image: {
        fileName: "blog-giving-back-06-2x",
        alt: "2 million meals donated",
        desktopWidth: "360",
        mobileWidth: "280",
        has2XWebp: "true",
      },
    },
  ];

  const hero = (
    <Hero
      variant="gybnmHero"
      heroTitle="You Grow, We Plant<span class='dot'>.</span>"
      heroContent="AnswerForce plants a tree for every customer, every month.<br class='desktop-only' /> Together, we can leave a legacy that lasts well beyond our lifetime."
      heroImgData={heroImgData}
      hasScrollToIntro={false}
      hasTreeCounter
    />
  );

  const promoSectionImage = {
    fileName: "scenic-banner-01",
    alt: "Scenic banner",
    desktopWidth: "100%",
    mobileWidth: "100%",
  };

  const communitySupportSectionImage = {
    fileName: "smiling-boy-car-apple",
    alt: "Smiling boy",
    desktopWidth: "100%",
    mobileWidth: "100%",
  };

  return (
    <Theme mainClassName="main" hero={hero} seo={seoData}>
      <PromoSection
        title="A legacy for future generations<span class='dot'>.</span>"
        content={[
          "Deforestation is a huge problem. Over <strong>15 million trees</strong> are cut down every year.<sup>1</sup> That's a lot of carbon dioxide not being<br class='desktop-only' /> sucked out of the air.",
        ]}
        cardTitle="Make an impact<span class='dot'>.</span>"
        cardContent={[
          "By planting our forest in Balquhidder, Scotland, and partnering with Epic Tree Partners, we're making an impact.  A tree for every customer and every team member, every month. Together, we make a difference.",
        ]}
        image={promoSectionImage}
        source="Source: <sup>1</sup> Time"
      />
      <BlogArticles
        title="Epic Tree Partners<span class='dot'>.</span>"
        content="Read about our Epic Tree Partners and the forest we're planting."
        cardData={blogCardData}
        linkText="Read more articles"
        href="https://www.answerforce.com/blog/us/category/giving-program/"
      />
      <CommunitySupportSection
        title="2.6 million meals<span class='dot'>.</span>"
        content={[
          "Between 2020 and 2024, we donated over 2.6 million meals to communities across the country. No one can reach their full potential when hungry or worried about putting food on the table.",
          "Thanks to our incredible customers we put food on tables and helped communities in the aftermath of natural disasters.",
        ]}
        image={communitySupportSectionImage}
      />
      <Discover
        bgColor="white"
        title="Get started with AnswerForce today<span class='dot'>.</span>"
        content="Have a tree planted for you every month."
        color="black"
        cta="See Prices"
        href={
          IS_LIVE
            ? "https://www.answerforce.com/register"
            : "https://testing.answerforce.com/register"
        }
      />
    </Theme>
  );
}
